export default __webpack_public_path__ + "static/media/elevate-swarovski-2.7762e646.png";